<template>
  <div>
    <b-overlay :show="loading">
      <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Roster Assignment
                    <span class="title-sub-text">
                        Assign rosters to employees based on location and department.
                    </span>
                </span>
                <span class="float-right"></span>
            </h4>
        </div>
      <div class="row mt-4">
        <div class="col-12">
          <b-form @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-12">

                <div class="row">
                  <div class="col" v-if="roster == null || roster.branch_id == null">
                    <b-form-group label="Select Work Location" label-for="branch_id" class="w-100 my-0 required-field">
                      <b-input-group>
                        <b-form-select id="branch_id" name="branch_id" v-model="fdata.branch_id" :options="branchOptions" v-validate="'required'" data-vv-as="Work Location"
                           class="w-100" aria-describedby="branch_id-feedback" @change="getEmployees(fdata.dept_id, fdata.branch_id)">
                          <template #first>
                            <b-form-select-option disabled :value="0">Select Work Location</b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-input-group>
                      <b-form-invalid-feedback id="branch_id-feedback" v-if="veeErrors.has('branch_id')">
                        {{ veeErrors.first('branch_id') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col" v-if="roster == null || roster.department_id == null">
                    <b-form-group label="Select Department" label-for="department_id" class="w-100 my-0 required-field">
                      <b-input-group>
                        <b-form-select :disabled="fdata.branch_id == 0" id="department_id" name="department_id" v-model="fdata.dept_id" :options="depertments" v-validate="'required'" data-vv-as="Department" class="w-100"
                                       aria-describedby="department_id-feedback" @change="getRosterAndDepartment(fdata.dept_id, fdata.branch_id)">
                          <template #first>
                            <b-form-select-option disabled :value="0">Select Department</b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-input-group>
                      <b-form-invalid-feedback id="department_id-feedback" v-if="veeErrors.has('department_id')">
                        {{ veeErrors.first('department_id') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group label="Select Roster" label-for="roster_id" class="required-field w-100 mt-0">
                      <b-form-select :disabled="fdata.dept_id == 0 || roster!=null" id="roster_id" name="roster_id" v-model="fdata.roster_id" :options="rosterOptions" v-validate="'required'" data-vv-as="Roster" data-vv-validate-on="change" :state="validateState('roster_id')" aria-describedby="roster_id-feedback" @change="selectRoster(fdata.roster_id)">
                        <template #first>
                          <b-form-select-option :value="null" disabled>Select Roster</b-form-select-option>
                        </template>
                      </b-form-select>
                      <b-form-invalid-feedback id="roster_id-feedback" v-if="veeErrors.has('roster_id')">
                        {{ veeErrors.first('roster_id') }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group id="effective_start_date-group" label="Effective Start Date" label-for="effective_start_date" class="required-field mt-0">
                      <b-input-group class="mb-0">
                        <b-form-input :disabled="fdata.roster_id == null" id="effective_start_date" name="effective_start_date" v-model="fdata.effective_start_date"
                            v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('effective_start_date')" aria-describedby="effective_start_date-feedback" data-vv-as="Period Start Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker :disabled="fdata.roster_id == null" :min="minDate" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.effective_start_date" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_start_date-feedback">
                          {{ veeErrors.first('effective_start_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group id="effective_end_date-group" label="Effective End Date" label-for="effective_end_date" class="required-field mt-0">
                      <b-input-group class="mb-0">
                        <b-form-input :disabled="fdata.roster_id == null" id="effective_end_date" name="effective_end_date" v-model="fdata.effective_end_date"
                            v-validate="{ required: true, date_format: 'yyyy-mm-dd' }" type="text" placeholder="YYYY-MM-DD"
                            autocomplete="off" :state="validateState('effective_end_date')" aria-describedby="effective_end_date-feedback" data-vv-as="Period Start Date"/>
                        <b-input-group-append class="mb-0">
                          <b-form-datepicker :disabled="fdata.roster_id == null" :min="minDate" class="mb-0" id="day_one" button-only right locale="en-US" v-model="fdata.effective_end_date" />
                        </b-input-group-append>
                        <b-form-invalid-feedback id="effective_end_date-feedback">
                          {{ veeErrors.first('effective_end_date') }}
                        </b-form-invalid-feedback>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>

              </div>

            </div>

            <div class="row" id="assignment">
              <div class="col-12">
                <div class="">
                  <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                               :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
                </div>
              </div>
            </div>

            <div v-if="fdata.roster_id" align="left" style="float: left; bottom: 0; z-index: 100;" class="position-sticky w-100 bg-white ibox p-3">
              <b-form-checkbox-group id="overlap-group" class="m-2" v-if="selectedRoster.shifts > 1">
                <div class="d-flex align-items-center">
                  <b-form-checkbox :disabled="loading" v-model="fdata.overlap" switch :value="1" :unchecked-value="0">Overlap In Week Off Days</b-form-checkbox>
                  <b-icon-info-circle class="text-info cursor-pointer" font-scale="1" variant="info"
                      v-b-tooltip.hover.top="'When enabled, off days do not affect the shift pattern sequence. When disabled, off days are skipped and the shift pattern continues from the next working day.'"
                      ></b-icon-info-circle>
                </div>
                <b-form-invalid-feedback id="overlap">{{ veeErrors.first('overlap') }}</b-form-invalid-feedback>
              </b-form-checkbox-group>
              <div>
                <b-button type="submit" variant="primary" class="m-2" :disabled="loading">
                  Assign to {{ employee_ids.length }} Employee(s)
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </b-overlay>


  </div>
</template>

<script>

import moment from "moment";

export default {
  props:['roster'],
  data(){
    return {
      loading:false,
      primary_key:'employee_id',
      company_options:[],
      y:2025,
      m:8,
      checkbox: 0,
      list_key:0,
      is_action: 0,
      custom_list: [],
      depertments: [],
      default_column:[ 'name','employee_code', 'jobposition'],
      appended_column: [
        { value: "branch", text: "Work Location", type: "text" },
        { value: "department", text: "Department", type: "text" },
        { value: "shift", text: "Today's Shift", type: "text" },
        { value: "off_day", text: "Off Day", type: "text" },
      ],
      fdata:{
        roster_id: this.roster ? this.roster.id : null,
        dept_id: this.roster ? this.roster.department_id : 0,
        branch_id: this.roster ? this.roster.branch_id : 0,
        effective_start_date: this.roster ? this.roster.period_start : '',
        effective_end_date: this.roster ? this.roster.period_end : '',
        overlap: 0,
      },
      employee_ids: [],

      rosterOptions: [],
      branchOptions: [],
      selectedRoster: {
        period_start: null,
        period_end: null,
        department_id: null,
        branch_id: null,
        shifts:0,
      }
    }
  },

  computed: {
    minDate () {
      const t = new Date(); t.setDate(t.getDate() + 1);
      const tomorrow = `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,'0')}-${String(t.getDate()).padStart(2,'0')}`;
      const start = this.selectedRoster && this.selectedRoster.period_start ? this.selectedRoster.period_start : null;
      return start;
      if (start) {
        if(start > tomorrow) {
          return start;
        }
        return tomorrow;
      }
      return tomorrow;
    },
  },
  watch: {
    selectedRoster: {
      immediate: true,
      deep: true,
      handler () {
        if (this.selectedRoster.period_end && this.minDate && this.selectedRoster.period_end < this.minDate) {
          this.effective_start_date = '';
          this.effective_end_date = '';
        }
      }
    }
  },

  methods:{
    moment,
    avatar(e){
      return `/avatar/${e.company_id}/${e.pic}`;
    },

    listReturn(data) {
      this.employee_ids = data.selected;
    },

    getRosterAndDepartment(dept_id,branch_id) {
      this.getRosters(dept_id, branch_id);
      this.getEmployees(dept_id, branch_id);
    },

    selectRoster(rosterId){
      this.checkbox = 1;
      const found = this.rosterOptions.find(el => el.id == rosterId || el.value == rosterId);
      this.selectedRoster = found || { period_start: null, period_end: null, branch_id: null, department_id: null, shifts:0 };
      this.fdata.effective_start_date = this.minDate;
      this.fdata.effective_end_date = this.selectedRoster.period_end;
    },

    getRosters(dept_id = 0, branch_id = 0) {
      if(!this.roster){
        this.fdata.roster_id = null;
      }
      this.effective_start_date = '';
      this.effective_end_date = '';
      this.fdata.overlap = 0;
      this.selectedRoster = { period_start: null, period_end: null, department_id: null, branch_id: null, shifts: 0 };

      axios.get(this.$api_url + '/leave-attendance/list', { params: { department_id: dept_id, branch_id: branch_id, type: 'list' } }).then(response => {
        this.rosterOptions = response.data;
        if(this.roster != null){
          this.selectRoster(this.roster.id);
        }
      });
    },
    getbranchList(){
      axios.get(this.$api_url + '/branch/list').then(response => {
        this.branchOptions = response.data;
      });
    },

    getDepartments: function(){
      axios.get(this.$api_url+'/department/list').then((response) => {
            this.depertments = response.data;
            if(this.roster == null){
              if(this.depertments.length > 0){
                // this.fdata.dept_id = this.depertments[0].id;
                this.getRosters(this.fdata.dept_id);
              }
            }
            else {
              this.getRosters(0);
            }

          });

    },

    getEmployees(department_id = 0, branch_id = 0) {
      this.fdata.effective_start_date = null;
      this.fdata.effective_end_date = null;
      let url = this.$api_url + '/leave-attendance/employees/list';
      let params = {
        roster:1,
        fields:'offday,roster,shift'
      };
      if (department_id != 0) params.department_id = department_id;
      if (branch_id != 0) params.branch_id = branch_id;
      this.list_key++;
      this.loading = true;
      axios.get(url, {params: params}).then(response => {
        this.list_key++;
        this.custom_list = response.data.employee_data;
        this.company_options = response.data.options;
        this.loading = false;
      });
    },

    parseYMD: function (dateStr) {
      const [y, m, d] = dateStr.split('-').map(Number);
      return new Date(y, m - 1, d);
    },

    onSubmit() {

      this.$validator.validateAll().then(valid => {
        if (!valid) {
          return;
        }

        if (this.employee_ids.length == 0) {
          this.$bvToast.toast("Please select employee(s) first",{
            variant:'danger',
            solid: true,
            title: 'Failed',
          });
          return;
        }

        const st = this.parseYMD(this.fdata.effective_start_date);
        const ed = this.parseYMD(this.fdata.effective_end_date);

        if (st > ed) {
          this.$bvToast.toast(
              "Effective End Date cannot be earlier than Effective Start Date.",
              {
                variant: 'danger',
                solid: true,
                title: 'Failed',
              }
          );
          return;
        }

        this.loading = true;

        const formData = new FormData();
        formData.append('employee_ids', JSON.stringify(this.employee_ids));
        Object.entries(this.fdata).forEach(([key, val]) => {
          formData.append(key, val);
        });

        axios.post(this.$api_url + '/leave-attendance/generate', formData).then(res => {
          this.resetForm();
          this.$validator.reset();
          this.employee_ids = [];
          this.list_key++;
          this.$bvToast.toast(res.data.message, {
                variant: 'success',
                title: 'Success',
                solid: true,
              });
          this.loading = false;
          this.list_key++;
          this.getEmployees();
        }).catch(e => {
          this.serverError(e);
          this.loading = false;
        });
      });
    },

    resetForm(){
      this.fdata = {
        roster_id: null,
        dept_id: 0,
        branch_id: 0,
        effective_start_date : '',
        effective_end_date : '',
        overlap: 0,
      };
      this.selectedRoster = { period_start: null, period_end: null, department_id: null, shifts: 0 };
    },

  },
  created() {
    this.getDepartments();
    this.getbranchList();
    this.$validator.reset();
    this.getEmployees();
  },
};
</script>
